import { useEffect } from 'react';
import { UsedBank } from 'library/types';
import { FormattedMessage } from 'react-intl';
import { renderAutoCompleteLocaleText } from 'utils';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import usedBanksActions from 'store/features/used-banks/actions';
import { Autocomplete, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material';
import { selectUsedBanks, selectUsedBanksIsEmpty } from 'store/features/used-banks/selector';

type ShowUsedBanksProps = {
  open: boolean;
  handleClose: () => void;
  clickedUsedBankIds: number[];
};

const ShowUsedBanks = ({ open, clickedUsedBankIds, handleClose }: ShowUsedBanksProps) => {
  // redux hooks
  const dispatch = useAppDispatch();
  const usedBanks = useAppSelector(selectUsedBanks);
  const isEmptyUsedBanks = useAppSelector(selectUsedBanksIsEmpty);

  // useEffect hooks
  useEffect(() => {
    if (!usedBanks.length && !isEmptyUsedBanks) {
      dispatch(usedBanksActions.getUsedBanks());
    }
  }, [usedBanks, isEmptyUsedBanks, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="report.usedBankIds" defaultMessage="Kullanılan Bankalar" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <Autocomplete
          readOnly
          multiple
          options={usedBanks}
          value={usedBanks.filter((usedBank) => clickedUsedBankIds.includes(usedBank.id))}
          {...renderAutoCompleteLocaleText()}
          getOptionLabel={(option: UsedBank) => option.title}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              slotProps={{
                input: {
                  ...params.InputProps,
                  disableUnderline: true,
                  endAdornment: null,
                },
              }}
            />
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShowUsedBanks;
